module.exports = __webpack_public_path__ + "assets/img/a78cba3f4abd681853c414472a23fa3f.png";